import WebsiteBuilderLogoAndBrand from "./WebsiteBuilderLogoAndBrand";
import WebsiteBuilderOverview from "./WebsiteBuilderOverview";
import WebsiteBuilderSettings from "./WebsiteBuilderSettings";
import WebsiteBuilderTemplatePreview from "./WebsiteBuilderTemplatePreview";
import WebsiteBuilderTemplates from "./WebsiteBuilderTemplates";

const websiteBuilderRoutes: { path: string; component: any }[] = [
  {
    path: "/admin/website-builder",
    component: WebsiteBuilderOverview,
  },
  {
    path: "/admin/website-builder/templates",
    component: WebsiteBuilderTemplates,
  },
  {
    path: "/admin/website-builder/templates/:templateId",
    component: WebsiteBuilderTemplatePreview,
  },
  {
    path: "/admin/website-builder-logo-and-brand",
    component: WebsiteBuilderLogoAndBrand,
  },
  {
    path: "/admin/website-builder-settings",
    component: WebsiteBuilderSettings,
  },
];

export default websiteBuilderRoutes;
